import React, { forwardRef } from "react"
import types from "prop-types"
import EllipsisIcon from "shared/icons/EllipsisIcon"

const ExpandMenuEllipsisButton = forwardRef((
  {
    ariaLabel, className, iconClassName, isOpen, ...rest
  },
  ref,
) => (
  <button
    aria-haspopup
    aria-expanded={isOpen}
    aria-label={ariaLabel}
    {...rest}
    ref={ref}
    className={className}
  >
    <EllipsisIcon className={iconClassName} ariaHidden />
  </button>
))

ExpandMenuEllipsisButton.defaultProps = {
  ariaLabel: "show menu",
  className: "",
  iconClassName: "",
  isOpen: false,
}

ExpandMenuEllipsisButton.propTypes = {
  ariaLabel: types.string,
  className: types.string,
  iconClassName: types.string,
  isOpen: types.bool,
}

ExpandMenuEllipsisButton.displayName = "ExpandMenuEllipsisButton"

export default ExpandMenuEllipsisButton
